/**
 * Censo Hogueras
 * Censo-Hogueras
 *
 * OpenAPI spec version: 1.0.0
 * Contact: you@your-company.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { PostRequestAsociado } from '../model/postRequestAsociado';
import { ResponseAsociaciones } from '../model/responseAsociaciones';
import { ResponseAsociados } from '../model/responseAsociados';
import { ResponseHistoricosAsociados } from '../model/responseHistoricosAsociados';
import { ResponseStatus } from '../model/responseStatus';
import { Status } from '../model/status';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({providedIn: 'root'})
export class AsociadosService {

    protected basePath = 'https://virtserver.swaggerhub.com/emjf1/Censo-Hogueras/1.0.0';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Eliminar un asociado
     * 
     * @param asociado 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public asociadosDelete(asociado: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseStatus>;
    public asociadosDelete(asociado: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseStatus>>;
    public asociadosDelete(asociado: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseStatus>>;
    public asociadosDelete(asociado: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (asociado === null || asociado === undefined) {
            throw new Error('Required parameter asociado was null or undefined when calling asociadosDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ResponseStatus>('delete',`${this.basePath}/asociados/${encodeURIComponent(String(asociado))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Listar todos los asociados
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public asociadosGet(observe?: 'body', reportProgress?: boolean): Observable<ResponseAsociados>;
    public asociadosGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseAsociados>>;
    public asociadosGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseAsociados>>;
    public asociadosGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ResponseAsociados>('get',`${this.basePath}/asociados`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtener un asociado
     * 
     * @param asociado 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public asociadosGetById(asociado: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseAsociados>;
    public asociadosGetById(asociado: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseAsociados>>;
    public asociadosGetById(asociado: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseAsociados>>;
    public asociadosGetById(asociado: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (asociado === null || asociado === undefined) {
            throw new Error('Required parameter asociado was null or undefined when calling asociadosGetById.');
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ResponseAsociados>('get',`${this.basePath}/asociados/${encodeURIComponent(String(asociado))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crear un nuevo asociado
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public asociadosPost(body: PostRequestAsociado, observe?: 'body', reportProgress?: boolean): Observable<ResponseAsociados>;
    public asociadosPost(body: PostRequestAsociado, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseAsociados>>;
    public asociadosPost(body: PostRequestAsociado, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseAsociados>>;
    public asociadosPost(body: PostRequestAsociado, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling asociadosPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ResponseAsociados>('post',`${this.basePath}/asociados`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Actualizar un asociado
     * 
     * @param body 
     * @param asociado 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public asociadosPut(body: ResponseAsociados, asociado: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseAsociados>;
    public asociadosPut(body: ResponseAsociados, asociado: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseAsociados>>;
    public asociadosPut(body: ResponseAsociados, asociado: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseAsociados>>;
    public asociadosPut(body: ResponseAsociados, asociado: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling asociadosPut.');
        }

        if (asociado === null || asociado === undefined) {
            throw new Error('Required parameter asociado was null or undefined when calling asociadosPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ResponseAsociados>('put',`${this.basePath}/asociados/${encodeURIComponent(String(asociado))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtener las asociaciones de un asociado específico
     * Retorna una lista de asociaciones a las que pertenece el asociado identificado por idAsociado.
     * @param idAsociado Identificador único del asociado.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAsociacionesByAsociado(idAsociado: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseAsociaciones>;
    public getAsociacionesByAsociado(idAsociado: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseAsociaciones>>;
    public getAsociacionesByAsociado(idAsociado: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseAsociaciones>>;
    public getAsociacionesByAsociado(idAsociado: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (idAsociado === null || idAsociado === undefined) {
            throw new Error('Required parameter idAsociado was null or undefined when calling getAsociacionesByAsociado.');
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ResponseAsociaciones>('get',`${this.basePath}/asociados/${encodeURIComponent(String(idAsociado))}/asociaciones`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtener el histórico del asociado
     * 
     * @param asociado 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getHistoricoByAsociado(asociado: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseHistoricosAsociados>;
    public getHistoricoByAsociado(asociado: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseHistoricosAsociados>>;
    public getHistoricoByAsociado(asociado: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseHistoricosAsociados>>;
    public getHistoricoByAsociado(asociado: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (asociado === null || asociado === undefined) {
            throw new Error('Required parameter asociado was null or undefined when calling getHistoricoByAsociado.');
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ResponseHistoricosAsociados>('get',`${this.basePath}/asociados/${encodeURIComponent(String(asociado))}/historico`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
